define('SageDotCom/Components/ProductCardComparisonTable',["jquery",
    "eventManager",
    "SageDotCom/Components/ProductCardAlignment",
    "underscore",
    "matchHeight",
    "slick",
    "SageDotCom/Components/SlickSliderSettings"],
    function ($, eventManager, productCardAlignment, _, mh, slick, SlickSliderSettings) {
        function ProductCardComparisonTable(scope, highlightColumns, numberOfColumns, tableId) {
            //Gap between the feature text or icon and the title of the row
            const featureTitleGap = 24;

            let fulltable = $(scope);
            tableId = $(scope).find("[id*='full-comparison-table-']").attr("id");

            let header = $(".product-comparison-sticky-header", fulltable);
            let headerId = tableId + "-header";
            let headerContainer = $(".sticky-header-container", header);
            let headerItems = $(".comparison-header-item", header);
            let headerHeight = header.height();

            let cardContainer = $(".product-cards-container", fulltable);
            let productCards = $(".product-cards-container .sage-product-card-outer", fulltable);

            let featureRows = $(".comparison-table-container .comparison-table-features", fulltable);

            let windowWidth = $(window).width();
            let oneColumnMargin = $(".container.score-page-layout-column1").css("margin-left");

            let startX;
            let endX;
            let startXHeader;
            let endXHeader;
            const sliderElement = document.querySelector("#" + tableId + " .product-comparison-table");

            let headerWasVisible = false;

            // hide overflow on stripe that table is in to avoid slick causing issues
            productCards.closest(".score-stripe").addClass("overflow-hidden position-relative");

            if (highlightColumns.length > 0) {
                _.each(highlightColumns, function (colNum) {
                    $(".comparison-table-feature-item:nth-child(" + colNum + ")", fulltable).addClass("highlighted");
                });
            }

            if (header !== null && header.length > 0) {
                header = $("body").find("#" + headerId);

                header.find(".comparison-header-item").css("max-width", "calc(100%/" + numberOfColumns + ")");

                positionHeader();
                headerContainer = $(".sticky-header-container", header);
                header.css("top", "-3000px");

                var prevArrow = $(".slick-prev", header);
                var nextArrow = $(".slick-next", header);
                prevArrow.css("left", "-52px");
                prevArrow.attr("tabindex", "-1");
                nextArrow.css("right", "-52px");
                nextArrow.attr("tabindex", "-1");

                // stops slicking/unslicking setting opacity to 0
                headerContainer.parent().addClass("animations-off");
                cardContainer.parent().addClass("animations-off");
                $(".comparison-table-container .comparison-table-row", fulltable).each(function () {
                    $(this).addClass("animations-off");
                });

                // fill in the header data
                populateHeader();

                const productCardContainer = document.querySelector("#" + tableId + " .product-cards-container");
                const tableContainer = document.querySelector("#" + tableId + " .comparison-table-container");
                headerHeight = header.height();

                setInterval(function () {
                    // show header when product cards are not in view but the table is
                    // take into account the height of the header so that when it does get shown, it is not overlapping the table
                    if (!isElementPartiallyInViewport(productCardContainer, false) &&
                        isElementPartiallyInViewport(tableContainer, true)) {
                        if (!headerWasVisible) {
                            if ($(headerContainer).hasClass("slick-initialized")) {
                                // show arrows
                                var prevArrow = $(".slick-prev", header);
                                var nextArrow = $(".slick-next", header);
                                prevArrow.css("left", "0");
                                prevArrow.hasClass("slick-disabled")
                                    ? prevArrow.attr("tabindex", "-1")
                                    : prevArrow.attr("tabindex", "0");
                                nextArrow.css("right", "0");
                                nextArrow.hasClass("slick-disabled")
                                    ? nextArrow.attr("tabindex", "-1")
                                    : nextArrow.attr("tabindex", "0");

                                $(".slick-active .comparison-header-item-cta-area .score-button", header).each(
                                    function () {
                                        $(this).attr("tabindex", "0");
                                    });
                            } else {
                                $(".comparison-header-item-cta-area .score-button", header).each(function () {
                                    $(this).attr("tabindex", "0");
                                });
                            }

                            headerMatchHeight();
                            header.css("top", "0");
                            headerWasVisible = true;
                        }
                    } else {
                        if (headerWasVisible) {
                            if ($(headerContainer).hasClass("slick-initialized")) {
                                var prevArrow = $(".slick-prev", header);
                                var nextArrow = $(".slick-next", header);
                                prevArrow.css("left", "-52px");
                                prevArrow.attr("tabindex", "-1");
                                nextArrow.css("right", "-52px");
                                nextArrow.attr("tabindex", "-1");
                            }
                            $(".comparison-header-item-cta-area .score-button", header).each(function () {
                                $(this).attr("tabindex", "-1");
                            });
                            header.css("top", "-3000px");
                            headerWasVisible = false;
                        }
                    }
                    headerHeight = header.height();
                },
                    500);
            }

            initSlick();

            //Event listeners for handling touch/swipe detection
            sliderElement.addEventListener("pointerdown", function (event) {
                startX = event.clientX;
            }, false);
            sliderElement.addEventListener("pointerup", function (event) {
                endX = event.clientX;
                var deltaX = endX - startX;
                handleSwipe(deltaX);
            }, false);

            // header is not part of sliderElement so need to add slider events to this too
            headerContainer.on("pointerdown", function (event) {
                startXHeader = event.clientX;
            });

            headerContainer.on("pointerup", function (event) {
                endXHeader = event.clientX;
                var deltaX = endXHeader - startXHeader;
                handleSwipe(deltaX);
            });

            function handleSwipe(deltaX) {
                if (!$(cardContainer).hasClass("slick-initialized")) {
                    // slick not enabled so no functionality should be fired
                    return;
                }

                let threshold = 60;
                if (Math.abs(deltaX) > threshold) {
                    if (deltaX > 0) {
                        headerContainer.slick("slickPrev");
                        cardContainer.slick("slickPrev");
                        featureRows.each(function () {
                            $(this).slick("slickPrev");
                        });
                    } else {
                        headerContainer.slick("slickNext");
                        cardContainer.slick("slickNext");
                        featureRows.each(function () {
                            $(this).slick("slickNext");
                        });
                    }
                }
            }
            function detachReAttachClean(parentEl, childSelector) {
                //Slicking changes the dom
                //This messes up styling when unslicking, so child elements need to be re-attached
                var items = $(parentEl).find(childSelector);
                items.detach();
                parentEl.empty();
                parentEl.append(items);
            }

            function initSlick() {
                windowWidth = $(window).width();
                if ((windowWidth >= 1080 && productCards.length <= 3) || (windowWidth < 1080 && windowWidth >= 768 && productCards.length <= 2) || (windowWidth < 768 && productCards.length <= 1)) {
                    // no need to have a slick slider for the cards as they will fit on the screen
                    // unslick and then return
                    if ($(cardContainer).hasClass("slick-initialized")) {

                        // remove changing sldes functionality as slick is no longer needed
                        cardContainer.off("afterChange");
                        $("slick-prev", headerContainer).off("click");
                        $("slick-next", headerContainer).off("click");

                        $(".comparison-table-section-title, .comparison-table-row-title", scope).each(function () {
                            $(this).removeClass("slicked-table");
                        });

                        //update rows to 0 to make sure unslicking works correctly
                        headerContainer.slick("slickSetOption", "rows", 0, true);
                        $(headerContainer).slick("unslick");
                        detachReAttachClean(headerContainer, ".comparison-header-item");

                        headerMatchHeight();

                        cardContainer.slick("slickSetOption", "rows", 0, true);
                        $(cardContainer).slick("unslick");
                        detachReAttachClean($(cardContainer), ".sage-product-card-outer");

                        featureRows.each(function () {
                            var parentRow = this;
                            $(parentRow).slick("slickSetOption", "rows", 0, true);
                            $(parentRow).slick("unslick");

                            detachReAttachClean($(parentRow), ".comparison-table-feature-item");
                        });

                        // scope for product cards has changed so repopulate variable
                        productCards = $(".product-cards-container .sage-product-card-outer", fulltable);
                        attachHeaderButtonEvents();
                    }
                    return;
                }
                if ($(cardContainer).hasClass("slick-initialized")) {
                    // cards need to be in slick slider but are already slicked so just return
                    attachHeaderButtonEvents();
                    return;
                }

                var headerSettings = SlickSliderSettings.getSlickProductComparisonSettings();
                headerSettings.arrows = true;
                headerSettings.dots = false;

                var cardSettings = SlickSliderSettings.getSlickProductComparisonSettings();
                cardSettings.arrows = false;

                var featureSettings = SlickSliderSettings.getSlickProductComparisonSettings();
                featureSettings.arrows = false;
                featureSettings.dots = false;

                headerContainer.slick(headerSettings);
                cardContainer.slick(cardSettings);

                // scope for product cards has changed so repopulate variable
                productCards = $(".product-cards-container .sage-product-card-outer", fulltable);

                featureRows.each(function () {
                    $(this).slick(featureSettings);
                });


                setRowTitleWidth();
                $(".comparison-table-section-title, .comparison-table-row-title", scope).each(function () {
                    var title = $(this);
                    if (!title.hasClass("slicked-table")) {
                        title.addClass("slicked-table");
                    }
                });

                var prioritisedCard = getPrioritisedCard();
                headerContainer.slick("slickGoTo", prioritisedCard);
                cardContainer.slick("slickGoTo", prioritisedCard);
                featureRows.each(function () {
                    $(this).slick("slickGoTo", prioritisedCard);
                });

                attachHeaderButtonEvents();
                productCardAlignment.sageProductCardMatchHeight();
            }

            function getPrioritisedCard() {
                var prioritisedCardSlideIndex = 0;
                for (i = 0; i < productCards.length; i++) {
                    var tempCard = $(productCards[i]).find(".sage-product-card-alt .header");
                    if (tempCard.hasClass("prioritised-card")) {
                        // first cards is prioritised
                        if (i === 0) {
                            prioritisedCardSlideIndex = 0;
                            break;
                        }
                        // last card is prioritised so use different calculation
                        if (i === productCards.length - 1) {
                            var fullSlidesShown = 1;
                            if (windowWidth < 1080 && windowWidth >= 768) {
                                fullSlidesShown = 2;
                            }
                            else if (windowWidth >= 1080) {
                                fullSlidesShown = 3;
                            }
                            prioritisedCardSlideIndex = productCards.length - fullSlidesShown;
                            break;
                        }
                        // middle card is prioritised 
                        if (windowWidth < 1080) {
                            prioritisedCardSlideIndex = i;
                        }
                        else {
                            prioritisedCardSlideIndex = i - 1;
                        }
                        break;
                    }
                }
                return prioritisedCardSlideIndex;
            }

            function populateHeader(currentProductSelection, elementChanged, isBundleTitle) {
                // find the relevant information from the product card and use it to populate the comparison header
                headerItems = $(".comparison-header-item", header);

                setTimeout(function () {
                    if (elementChanged !== null && elementChanged !== "" && elementChanged !== undefined) {
                        // only need to update one header item's content
                        var parentCard = $(elementChanged).parents(".sage-product-card-outer");
                        var parentCardIndex = parentCard.attr("data-index");
                        var parentTableId = $(elementChanged).parents("[id*='full-comparison-table-']").attr("id");
                        if (header.attr("id") === parentTableId + "-header") {
                            // elementChanged is in this comparison table so update header item
                            var headerItemToUpdate = $(headerItems[parentCardIndex]);
                            populateOneHeaderItem(parentCard, headerItemToUpdate, currentProductSelection, isBundleTitle);
                        }

                    } else {
                        // populate all header items
                        for (var i = 0; i < productCards.length; i++) {
                            var currentCard = $(productCards[i]);
                            var currentHeaderItem = $(headerItems[i]);
                            currentHeaderItem.attr("data-index", i);
                            currentCard.attr("data-index", i);

                            populateOneHeaderItem(currentCard, currentHeaderItem, currentProductSelection, isBundleTitle);
                        }
                    }

                    var headerButtons = $(".comparison-header-item .comparison-header-item-cta-area .score-button", header);
                    $(headerButtons).each(function (bi, button) {
                        if (!$(button).hasClass("btn-sm")) {
                            $(button).addClass("btn-sm");
                        }
                    });

                    attachHeaderButtonEvents();
                    setRowTitleWidth();
                    headerMatchHeight();
                    productCardAlignment.sageProductCardMatchHeight();
                }, 500);
            }

            function populateOneHeaderItem(currentCard, currentHeaderItem, currentProductSelection, isBundleTitle) {

                var headerTitle = $(".comparison-header-item-title", currentHeaderItem);
                var headerPrice = $(".comparison-header-item-price", currentHeaderItem);
                var headerCTAArea = $(".comparison-header-item-cta-area", currentHeaderItem);

                var cardTitle;
                if (currentProductSelection !== null && currentProductSelection !== "" && currentProductSelection !== undefined) {
                    if (!isBundleTitle) {
                        cardTitle = currentProductSelection + " + " + $(".sage-product-card-title-area .sage-product-card-title", currentCard).text();
                    }
                    else {
                        cardTitle = currentProductSelection;
                    }
                }
                else {
                    cardTitle = $(".sage-product-card-title-area .sage-product-card-title", currentCard).text();
                }
                headerTitle.text(cardTitle);

                var bundledCardPrice = $(".sage-product-card-price-options-area .sage-product-card-bundle-price-box .sage-product-card-bundle-price-details .price", currentCard);
                var cardPrice = bundledCardPrice !== null && bundledCardPrice.length > 0 ? bundledCardPrice.text() : $(".sage-product-card-price-options-area .sage-product-card-price-box .price", currentCard).text();
                headerPrice.text(cardPrice);

                if (!$(cardContainer).hasClass("slick-initialized")) {
                    // slick handled tab indexes so only run if slick if not being ran on the table
                    $(".sage-product-card-actions-area .score-button", currentCard).each(function () {
                        $(this).attr("tabindex", "0");
                    });
                }
                var cardActions = $(".sage-product-card-actions-area", currentCard).html();
                headerCTAArea.html(cardActions);
                $(headerCTAArea).find(".button-micro-text-container p.micro-text").css("width", "auto");
            }

            function attachHeaderButtonEvents() {
                eventManager.trigger("multistep-reattach-next-step-events");

                if ($(headerContainer).hasClass("slick-initialized")) {
                    // attach click events for slick arrows
                    // still need to manually trigger slickPrev/slickNext on header as .off() will remove slick.js click events too
                    $(".slick-prev", headerContainer).off().on("click", function () {
                        headerContainer.slick("slickPrev");
                        cardContainer.slick("slickPrev");
                        featureRows.each(function () {
                            $(this).slick("slickPrev");
                        });
                    });

                    $(".slick-next", headerContainer).off().on("click", function () {
                        headerContainer.slick("slickNext");
                        cardContainer.slick("slickNext");
                        featureRows.each(function () {
                            $(this).slick("slickNext");
                        });
                    });
                }

                if ($(cardContainer).hasClass("slick-initialized")) {
                    // attach click events for slick dots
                    // still need to manually trigger goto on cards as .off() will remove slick.js click events too
                    $(".slick-dots button", cardContainer).off().on("click", function () {
                        var dotIndex = parseInt($(this).text()) - 1;
                        headerContainer.slick("slickGoTo", dotIndex);
                        cardContainer.slick("slickGoTo", dotIndex);
                        featureRows.each(function () {
                            $(this).slick("slickGoTo", dotIndex);
                        });
                    });
                }

                header = $("body").find("#" + headerId);
                // attach event listener for multi step panel next step button in comparison header like button on product card
                var nextStepButtons = $(".comparison-header-item .multi-step-panel-next-step-btn", header);
                $(nextStepButtons).each(function (bi, button) {
                    //remove old click events from previous header population (eg. initial load, then dynamic price box loads so it is triggered again) then readd
                    $(button).off("click").on("click", function () {
                        // find the equivalent button on the product card and trigger click to make sure the correct sku and url is used
                        var headerItemIndex = $(button).parents(".comparison-header-item").attr("data-index");
                        var productCardButton = $(".sage-product-card-outer .multi-step-panel-next-step-btn", cardContainer)[headerItemIndex];
                        productCardButton.click();
                    });
                });

                // attach event listener for suites v1 feature list modal button
                var featureListButtons = $(".comparison-header-item .modal-launch-btn", header);
                $(featureListButtons).each(function (bi, button) {
                    //remove old click events from previous header population
                    $(button).off("click").on("click", function () {
                        // find the equivalent button on the product card and trigger click to call modal popup
                        var headerItemIndex = $(button).parents(".comparison-header-item").attr("data-index");
                        var productCardButton = $(".sage-product-card-outer .modal-launch-btn", cardContainer)[headerItemIndex];
                        productCardButton.click();
                    });
                });
            }

            function isElementPartiallyInViewport(el, isTable) {
                // Special bonus for those using jQuery
                if (typeof jQuery !== "undefined" && el instanceof jQuery)
                    el = el[0];
                var rect = el.getBoundingClientRect();
                var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
                // take into account the height of the comparison table header so that when it appears it does not overlap the table
                var vertInView = isTable ? (rect.top - headerHeight <= windowHeight) && (rect.bottom >= headerHeight) : (rect.top <= windowHeight) && (rect.bottom >= headerHeight);

                return (vertInView);
            }

            function headerMatchHeight() {
                $(".comparison-header-item-title", header).matchHeight({ byRow: true });
                $(".comparison-header-item-price", header).matchHeight({ byRow: true });
                $(".comparison-header-item-cta-area", header).matchHeight({ byRow: true });
                headerHeight = header.height();
            }

            function positionHeader() {
                windowWidth = $(window).width();
                if (windowWidth >= 1080) {
                    oneColumnMargin = $(".container.score-page-layout-column1").css("margin-left");
                    header.css("margin-left", "-" + oneColumnMargin);
                    header.css("margin-right", "-" + oneColumnMargin);
                }
                else {
                    header.css("margin-left", "");
                    header.css("margin-right", "");
                }

                //ensure stuck to the left side of the screen
                var leftPos = header.offset().left;
                if (leftPos !== 0) {
                    var currLeftMargin = parseFloat(header.css("margin-left"));
                    var newLeftMargin = currLeftMargin - leftPos;
                    header.css("margin-left", newLeftMargin + "px");
                }
            }

            function setRowTitleWidth() {
                //For each row, get the title
                //Title width needs to be restricted to be, at most, the width of a single column
                //Make each feature have the padding of the row on the top
                $(scope).find(".comparison-table-row").each(function (i, row) {
                    const titleEl = $(row).find(".comparison-table-row-title");
                    const features = $(row).find(".comparison-table-feature-item");
                    const featureWidth = features.width();
                    titleEl.width(featureWidth);

                    const titleHeight = titleEl.outerHeight(true);
                    features.height("auto");
                    features.css("padding-top", (titleHeight + featureTitleGap) + "px");
                });

                //Finally, match height them all
                $(scope).find(".comparison-table-feature-item").matchHeight({ byRow: true });
            }

            const resizeFunc = function () {
                //reset to default
                headerWasVisible = false;
                headerMatchHeight();
                initSlick();
                positionHeader();
                eventManager.trigger("slick-comparison-table-refresh");
            };

            let resizeTimeout;
            const setResizeTimeout = function () {
                resizeTimeout = window.setTimeout(function () {
                    resizeFunc();
                }, 200);
            }

            $(window).on("resize", function () {
                window.clearTimeout(resizeTimeout);

                setResizeTimeout();
            });

            eventManager.subscribe("multi-step-panel-change", function (panelId) {
                //only start doing resize calculations if this is the relevant panel
                var panel = $(scope).parents("#" + panelId);
                if (panel.length > 0) {
                    //ensure that the panel has been switched before doing the calculations
                    var visibleInterval = setInterval(function () {
                        if (panel.is(":visible")) {
                            clearInterval(visibleInterval);
                            setResizeTimeout();
                        }
                    }, 10);
                }
            });

            eventManager.subscribe("slick-comparison-table-refresh", function () {
                if ($(cardContainer).hasClass("slick-initialized")) {
                    var currentSlideIndex = cardContainer.slick("slickCurrentSlide");
                    headerContainer.slick("slickGoTo", currentSlideIndex);
                    cardContainer.slick("slickGoTo", currentSlideIndex);
                    featureRows.each(function () {
                        $(this).slick("slickGoTo", currentSlideIndex);
                    });
                }

                setRowTitleWidth();

                setTimeout(function () {
                    setRowTitleWidth();
                    attachHeaderButtonEvents();
                    headerMatchHeight();
                    productCardAlignment.sageProductCardMatchHeight();
                }, 1500);

            });

            eventManager.subscribe("populate-comparison-header", function (currentProductSelection, elementChanged, isBundleTitle) {
                populateHeader(currentProductSelection, elementChanged, isBundleTitle);
                setResizeTimeout();
            });
        }

        function ProductCardComparisonTableV3(scope, highlightColumns, numberOfColumns, tableId) {
            const $scope = $(scope);

            // Take table headings and insert them next to first section header
            const productCardsContainer = $scope.find(".product-cards-container");
            const firstSectionHeader = $scope.find(".product-comparison-section-header").get(0);

            if (firstSectionHeader) {
                productCardsContainer.appendTo(firstSectionHeader);
            }

            const setHeaderWidth = () => {
                const sectionHeaders = $scope.find(".product-comparison-section-header");
                const $rowTitle = $scope.find(".comparison-table-row-title").first();
                const $featuresContainer = $scope.find(".comparison-table-features").first();
                const $featureItems = $featuresContainer.find(".comparison-table-feature-item");

                if (!$rowTitle.length || !$featureItems.length) return;

                const rowTitleWidth = $rowTitle.outerWidth() || 0;
                const featureWidth = $featureItems.first().outerWidth() || 0;
                const featureCount = $featureItems.length;
                const totalWidth = (featureWidth * featureCount) + rowTitleWidth;

                sectionHeaders.width(totalWidth);
            };

            // Resize each row, match the height between the row content and the title
            const resizeHeights = () => {
                $(".comparison-table-row > div", $scope).matchHeight({ byRow: true });
                $(".comparison-table-section:not('.ai-styling') .product-comparison-section-header, .comparison-table-section:not('.ai-styling') .product-comparison-section-header > *", $scope).matchHeight({ byRow: true });
            };

            // Disable animations
            productCardsContainer.parent().addClass("animations-off");
            $(".comparison-table-container .comparison-table-row", $scope).addClass("animations-off");

            // Debounce resize event
            var resizeTimeout;
            const onResize = () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    if (window.matchMedia('(max-width: 1079px)').matches) {
                        setHeaderWidth();
                    } else {
                        $scope.find(".product-comparison-section-header").css('width', '');
                    }
                    resizeHeights();
                }, 200);
            };

            $(window).on("resize", onResize);

            if (window.matchMedia('(max-width: 1079px)').matches) {
                setHeaderWidth();
            }

            resizeHeights();
        }

        ProductCardComparisonTable.init = function init(args) {
            if (args.IsEditorEditing === true) return null;

            return args.useVersion3 === true
                ? new ProductCardComparisonTableV3(args.scope, args.highlightColumns, args.numberOfColumns, args.tableId)
                : new ProductCardComparisonTable(args.scope, args.highlightColumns, args.numberOfColumns, args.tableId);
        };

        return ProductCardComparisonTable;
    });
